import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c(VContainer,{staticClass:"pa-0"},[_c(VBtnToggle,{attrs:{"mandatory":"","background-color":"background"}},[_c(VRow,{attrs:{"justify":"center"}},_vm._l((_vm.options),function(option,i){return _c(VBtn,{key:i,staticClass:"ma-1",attrs:{"small":"","rounded":"","color":"tertiary","light":""},on:{"click":function($event){return _vm.Select(option.value)}}},[_vm._v(_vm._s(option.text))])}),1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }